export class Rating {
	constructor() {
		this.cachedValue = 0.0;
		this.currentRatingContainer = null;
		let _this = this;

		$('.c-ratings__own a').on('click', function (e) {
			e.preventDefault();
			_this.currentRatingContainer = $(this).parent().parent().parent();
			_this.toggle();
		});
		$('.c-ratings__own-input i').on('mousemove', function (e) {
			_this.highlightStars($(this), e.pageX);
		})
		$('.c-ratings__own-input i').on('mouseenter mouseout', function (e) {
			e.stopPropagation()
		})
		$('.c-ratings__own-input').on('mouseout', function (e) {
			_this.revertRating($(this));
		})
		$('.c-ratings__own-input i').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation()
			_this.rate($(this).parent(), $(this), e.pageX);
		})
	}

	toggle() {
		let $rating = this.currentRatingContainer.find('.c-ratings__own-input');
		if ($rating.is(':visible')) {
			this.hideRating($rating)
		} else {
			this.hideRating($('.c-ratings__own-input:visible'))
			this.cachedValue = $rating.data('rating');
			this.showRating($rating)
		}
	}

	showRating($rating) {
		$rating.show()
		$rating.animate({ "right": "0px" }, 'fast');
	}

	hideRating($rating) {
		$rating.animate({ "right": "-175px" }, 'fast', function() {
			$rating.hide()
		});
	}

	rate($starContainer, $star, pageX) {
		let value = this.isOverFirstHalfOfStar($star, pageX) ? 0.5 : 1.0;
		value += $star.prevAll().length;

		this.cachedValue = value;
		$starContainer.data('rating', value);

		let $form = $('#rateForm');
		$form.children('input[name="tx_vetagenda_agenda[webinar]"]').val($starContainer.data('webinar'));
		$form.children('input[name="tx_vetagenda_agenda[value]"]').val(value);

		this.submitRating($form);
	}

	submitRating($form) {
		let _this = this;

		$.ajax({
			type: "POST",
			url: $form.attr('action'),
			data: $form.serialize(),
			success: function() {
				_this.currentRatingContainer.find('.c-ratings__own i').removeClass('fa-star-o').addClass('fa-star');
				_this.currentRatingContainer.find('.c-ratings__own a span').html('Modify');
				_this.hideRating($('.c-ratings__own-input'));
			}
		});
	}

	highlightStars($star, pageX) {
		let $wrapper = $star.parent();
		let firstHalf = this.isOverFirstHalfOfStar($star, pageX);
		let className = firstHalf ? 'fa-star-half-o' : 'fa-star';

		$wrapper.children('i').removeClass('fa-star').removeClass('fa-star-o').removeClass('fa-star-half-o');
		$star.addClass(className);
		$star.nextAll().addClass('fa-star-o');
		$star.prevAll().addClass('fa-star');
	}

	revertRating($wrapper) {
		$wrapper.children('i').each((i, star) => {
			let $star = $(star)
			$star.removeClass('fa-star fa-star-o fa-star-half-o');
			if (i < this.cachedValue) {
				if (this.cachedValue === (i + 0.5)) {
					$star.addClass('fa-star-half-o');
				} else {
					$star.addClass('fa-star');
				}
			} else {
				$star.addClass('fa-star-o');
			}
		});
	}

	isOverFirstHalfOfStar($star, pageX) {
		let left = Math.abs(pageX - $star.offset().left);

		return ($star.width() / 2) > left;
	}
}
